var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReactjs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 61 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.694 35.678a5.348 5.348 0 1 0 0-10.695 5.348 5.348 0 0 0 0 10.695Z",
    fill: "#61DAFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.696 41.287c15.848 0 28.695-4.905 28.695-10.956 0-6.052-12.847-10.957-28.695-10.957C14.847 19.374 2 24.279 2 30.331c0 6.05 12.848 10.956 28.696 10.956Z",
    stroke: "#61DAFB",
    strokeWidth: 2.609
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.205 35.809C29.129 49.534 39.8 58.207 45.04 55.182c5.24-3.026 3.065-16.605-4.86-30.33C32.259 11.128 21.587 2.454 16.346 5.48c-5.24 3.025-3.064 16.604 4.86 30.329Z",
    stroke: "#61DAFB",
    strokeWidth: 2.609
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.204 24.853c-7.924 13.724-10.1 27.303-4.859 30.329 5.24 3.025 15.912-5.648 23.837-19.373 7.924-13.725 10.1-27.304 4.859-30.33-5.24-3.025-15.913 5.649-23.837 19.374Z",
    stroke: "#61DAFB",
    strokeWidth: 2.609
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReactjs);
export default __webpack_public_path__ + "static/media/reactjs.ec8f104408f2d790301bdb930ecabe7d.svg";
export { ForwardRef as ReactComponent };